// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react'
// @end dependencies

// @import components
import ButtonComponent from 'app_components/commons/Button/ButtonComponent'
import InputComponent from 'app_components/commons/Input/InputComponent'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import { Modal } from 'react-bootstrap'
// @end components

// @import types
// @end types

// @import services
import SurveyService from 'app_services/admin/academicContent/survey/surveyService';
// @end services

// @import hooks
import { useForm } from 'react-hook-form';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ModalSatisfactionReport.scss'
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent'
import CheckBoxComponent from 'app_components/commons/checkBox/containers/checkBoxComponent';
// @end styles

interface IModalSatisfactionReportProps {
  open: boolean
  className?: string
  classNameModal?: string
  style?: CSSProperties
  id?: string
  onClose?: ()=>any
}

const ModalSatisfactionReport: React.FC<IModalSatisfactionReportProps> = (props) => {

  const [loading, updateLoading] = useState<boolean>(false);

  const form = useForm();
  const statusSpy: boolean = form.watch('status', false);

  const surveyService = new SurveyService();

  useEffect(() => {
    form.setValue('status', false)
    form.register('status')
  }, [])

  const handleClickClose = () => {
    form.setValue('status', false)
    if(props.onClose){
      props.onClose()
    }
  }

  const handleSubmitForm = async () => {
    const datos = form.getValues();
    updateLoading(true);
    if (datos) {
      if (datos?.status === true) {
        datos.status = 'all'
      } else {
        delete datos.status
      }
      const response = await surveyService.generateReport(datos as any);
      if (response?.code === 200 && response?.path) {
        window.open(response.path, '_blank', 'noreferrer');
      }
    }
    updateLoading(false);
    handleClickClose();
  }

  return(
    <Modal
      className={`modal-learning-path-container ${props.classNameModal ? props.classNameModal : ''}`}
      show={props.open}
      onHide={handleClickClose}
      centered
    >
      <Modal.Body
        style={{
          padding: '0px'
        }}
      >
        <form
          className={`modal_satisfaction_report-layout ${props.className ? props.className : ''}`}
          style={props.style}
          id={props.id}
          onSubmit={form.handleSubmit(handleSubmitForm)}
        >
          <TextComponent
            type='subtitle'
          >
            Generar reporte de satisfacción
          </TextComponent>
          <div className="container-form-satisfaction">
            <InputComponent
              type='date'
              label='Desde'
              name='startDate'
              formHook={form.register({required: false})}
              invalid={form.errors['startDate']}
              invalidText='Este campo es requerido'
            />
            <InputComponent
              type='date'
              label='Hasta'
              name='endDate'
              formHook={form.register({required: false})}
              invalid={form.errors['endDate']}
              invalidText='Este campo es requerido'
            />
            <div>
              <LabelComponent className='mr-2'>
                Incluir encuestas desactivadas
              </LabelComponent>
              <CheckBoxComponent
                checked={statusSpy}
                onClick={() => form.setValue('status', !statusSpy)}
              />
            </div>
          </div>
          <div className="container-actions-satisfaction">
            <ButtonComponent
              variant='secondary'
              type='button'
              onClick={handleClickClose}
            >
              Cancelar
            </ButtonComponent>
            <ButtonComponent
              variant='primary'
              type='submit'
              loading={loading}
            >
              Generar
            </ButtonComponent>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default ModalSatisfactionReport;
